/* eslint-disable no-console */

if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => Promise.all(registrations.map(registration => registration.unregister())))
    .then(() => {
      if (!window.caches || typeof window.caches.keys !== 'function') return

      return window.caches.keys().then((cacheNames) => {
        return Promise.all(cacheNames.map(cacheName => window.caches.delete(cacheName)))
      })
    })
    .then(() => {
      console.log('Service worker registrations and caches cleared to avoid stale chunk issues.')
    })
    .catch((error) => {
      console.error('Failed to clear service worker registrations:', error)
    })
}
